import axios from 'axios';
import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useForm } from 'react-hook-form';
import { FaLocationArrow, FaCalendarCheck, FaAngleRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase.init';
import useUser from '../../hooks/useUser';
import useSpots from '../../hooks/useSpots';

const Showcase = () => {

    let navigate = useNavigate();

    const [user, loading] = useAuthState(auth);
    const [userc] = useUser(user?.email);
    const [spots] = useSpots();

    const today = new Date();
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1);
    const minDate = tomorrow.toISOString().split("T")[0];
    //console.log(minDate);

    const handleNewPost = async (newPost) => {
        await axios.post("https://tripaide-server.onrender.com/posts", newPost)
            .then(res => {
                //console.log(res.data.insertedId);
                const id = res.data.insertedId;
                navigate(`/newpost/${id}`);
            });
    };

    const { register, handleSubmit } = useForm();
    const onSubmit = (data) => {
        if (user?.email) {
            //console.log(data);
            const newPost = {
                uid: userc?._id,
                owner: userc?.name,
                spot: data?.district,
                spotId: spots?.find(sp => sp?.district === data?.district)._id,
                date: data?.date,
                state: 'Incomplete',
                isReported: false,
                isReviewed: false,
                reporter: "",
                guide: "",
                guideId: "",
                interested: [
                    {
                        id: userc?._id,
                        name: userc?.name
                    }
                ],
                job: [
                    {
                        id: userc?._id,
                        name: userc?.name
                    }
                ]
            };
            //console.log(newPost);
            handleNewPost(newPost);
        } else {
            navigate('/login');
        }

    };

    return (
        <div className='px-8 md:px-32 py-16 md:py-16 2xl:py-32 text-white'>
            <h1 className='lg:mt-8 text-6xl font-semibold'>Welcome to <br /><span className='text-yellow-500 mt-2 inline-block'>trip</span>aide</h1>
            <p className='my-4 text-xl lg:w-1/2'>What's the fun in travelling alone? Let's find your perfect tour partners, guides, packages and many more!</p>
            <form onSubmit={handleSubmit(onSubmit)} className='lg:mb-8 py-8'>
                <div className='lg:flex'>
                    <div className='flex items-center lg:mr-8'>
                        <label className='text-2xl font-semibold mr-4'>Where to? </label> <br />
                        <div className='flex'>
                            <span className='block p-2 bg-trans text-white border-r-2 rounded-l-lg'><FaLocationArrow className='block' /></span>
                            <select required className='block px-4 bg-trans text-white rounded-r-lg' {...register("district", { required: true })} placeholder="Destination">
                                <option value="Cox’s Bazar">Cox’s Bazar</option>
                                <option value="Bagerhat">Bagerhat</option>
                                <option value="Dhaka">Dhaka</option>
                                <option value="Chittagong">Chittagong</option>
                                <option value="Rangamati">Rangamati</option>
                                <option value="Bandarban">Bandarban</option>
                                <option value="Teknaf">Teknaf</option>
                                <option value="Naogaon">Naogaon</option>
                                <option value="Kuakata">Kuakata</option>
                                <option value="Sylhet">Sylhet</option>
                                <option value="Barisal">Barisal</option>
                                <option value="Khagrachari">Khagrachari</option>
                                <option value="Rajshahi">Rajshahi</option>
                                <option value="Chandpur">Chandpur</option>
                                <option value="Cumilla">Cumilla</option>
                            </select>
                        </div>
                    </div>
                    <div className='flex items-center py-4'>
                        <label className='text-2xl font-semibold mr-4'>When? </label> <br />
                        <div className='flex'>
                            <span className='block p-2 bg-trans text-white border-r-2 rounded-l-lg'><FaCalendarCheck className='block' /></span>
                            <input required min={minDate} type='date' className='block px-4 bg-trans text-white rounded-r-lg' {...register("date", { required: true })} placeholder="Date" />
                        </div>
                    </div>
                </div>
                <button className='block mt-4 bg-yellow-500 text-lg text-gray-900 hover:shadow-lg px-3 py-2 rounded-md font-semibold cursor-pointer' type="submit">
                    Create A Post <FaAngleRight className='ml-1 inline-block' />
                </button>
            </form>

        </div >
    );
};

export default Showcase;